import {ReactElement, useState} from 'react';

import {useTranslation} from 'react-i18next';

import CheckIcon from '@mui/icons-material/Check';
import {Grid, TextField, Typography, useTheme} from '@mui/material';

import {inviteApplicantModalStyles} from './styles/InviteApplicantModalStyles';
import {CopyLinkIcon} from '../../../../assets/icons';
import {EmpionButton} from '../../../../components/EmpionButton/EmpionButton';
import {greenColors} from '../../../../layouts/theme/designSystem';
import {copyTextToClipBoard} from '../../../../utils/copyTextToClipboard/copyTextToClipBoard';

interface Props {
  surveyUrl: string;
}

export const InviteToScreening = ({surveyUrl}: Props) => {
  const theme = useTheme();
  const {t: tr} = useTranslation('translation', {keyPrefix: 'screeningModule.inviteApplicantModal'});

  const [buttonText, setButtonText] = useState(tr('copyLinkButton'));
  const [icon, setIcon] = useState(<CopyLinkIcon fill={'white'} />);

  const handleCoppyLink = async () => {
    if (!surveyUrl) return;

    const res = await copyTextToClipBoard(`${surveyUrl}?source=screening_applicant`);
    if (res) {
      setButtonText(tr('copyLinkSuccess'));
      setIcon(<CheckIcon />);
      setTimeout(() => {
        setButtonText(tr('copyLinkButton'));
        setIcon(<CopyLinkIcon fill={'white'} />);
      }, 1000);
    } else {
      setButtonText(tr('copyLinkError'));
      setIcon(<CheckIcon />);
      setTimeout(() => {
        setButtonText(tr('copyLinkButton'));
        setIcon(<CopyLinkIcon fill={'white'} />);
      }, 1000);
    }
  };

  const renderCopyLinkButton = (): ReactElement => {
    return (
      <EmpionButton onClick={handleCoppyLink} sx={{marginLeft: 1, minWidth: 'fit-content'}}>
        <Typography
          variant='h4'
          sx={{cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1, color: 'white'}}
        >
          {icon}
          {buttonText}
        </Typography>
      </EmpionButton>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          variant='h3'
          marginBottom={5}
          sx={{
            color: greenColors[900],
            fontWeight: 400,
          }}
        >
          {tr('copyAndSend')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          value={surveyUrl}
          variant='outlined'
          sx={{...inviteApplicantModalStyles(theme).fieldStyles, marginBottom: 0}}
          InputProps={{
            readOnly: true,
            endAdornment: renderCopyLinkButton(),
          }}
        />
      </Grid>
    </Grid>
  );
};
